//import liraries
import React, { Component, useEffect, useState, useRef } from "react";
import { View, Text, Image, TouchableOpacity, TextInput, Linking,} from "react-native";
import CustomButton from "../../common/CustomButton";
import {  getCreditCardDetails, getAutoRechargeDtls, updateAutoRechargeStatus, sendOtp, validateOtpWithToken,} from "../../api/apiManager";
import { get } from "lodash";
import QuickLinks from "./QuickLinks";
import Countdown from "react-countdown";
import CustomInput from "../../common/CustomInput";
import ModalAlert from "../../common/ModalAlert";
import ModalAlertForTwoButtons from "../../common/ModalAlertForTwoButtons";
import Loader from "../../common/Loader";
import { useOutletContext, useLocation } from "react-router-dom";
import * as RootNavigation from "../../utilities/RootNavigation";
import useStyles from "./AutoRecharge_Styles";
import CText from "../../common/CText";
import CImage from "../../common/CImage";

// create a component
const AutoRecharge = (props) => {
  const { selectedVrn } = useOutletContext()
  const {state } = useLocation()
  const selectedVrnData = state?.selectedVrnData
  console.log(selectedVrnData,selectedVrn,'selectedVrnData3')
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("500");
  const [creditCardModal, setCreditCardModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [errMessage, setErrMessage] = useState( "IDFC FIRST Bank Credit Card is not linked with your mobile number. Would you like to apply?");
  const [data, setData] = useState([]);
  const [ccdata, setccData] = useState([]);
  const [apiLoader, setApiLoader] = useState(false);
  const [otpNbr, setOtpNbr] = useState("");
  const [otpMsg, setOtpMsg] = useState("");
  const [errModalVisible, setErrModalVisible] = useState(false);
  const [otpData, setOtpData] = useState("");
  const [requestId, setRequestId] = useState("");
  const [showUpdate,setShowUpdate] = useState(false)
  const otpPattern = /^\d{6}$/;
  const [selectedCard, setSelectedCard] = useState({});
  const [thresholdAmt, setThresholdAmt] = useState(0);
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [otp, setOtp] = useState();
  const styles = useStyles();
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({ title: "", status: "", message: "", navigateScreen: "", actionButton: "",});
  const counterRef = useRef(null);
  const [timerState, setTimeState] = useState("");

  useEffect(() => {
    if (otpModalVisible)
      setTimeState({
        times: [ Date.now() + 5000, Date.now() + 12000, Date.now() + 17000,   Date.now() + 22000, ],
        currentTimeIndex: 0,
        currentTime: Date.now() + 60000,
      });
  }, [otpModalVisible]);

  const timerRenderer = ({ hours, minutes, seconds, completed, api }) => {
    if (completed || isNaN(minutes)) {
      return (
        <>
          <Text>{"00:00"}</Text>
          <TouchableOpacity
            onPress={() => {
              setTimeState({
                times: [ Date.now() + 5000, Date.now() + 12000, Date.now() + 17000, Date.now() + 22000, ], currentTimeIndex: 0, currentTime: Date.now() + 60000,
              });
              setTimeout(() => {
                api.start();
              }, 500);
            }}
          >
            <Text style={styles.resendTextStyle}>{"Resend"}</Text>
          </TouchableOpacity>
        </>
      );
    }
    return (
      <>
        <Text> {minutes}:{seconds} </Text>
        <View> <Text style={[styles.resendTextStyle, { color: "gray" }]}>  {"Resend"}</Text>  </View>
      </>
    );
  };

  const completeTime = () => {
    if ( timerState.times.length - 1 <= timerState.times.indexOf(timerState.currentTime) )
      return;
    // move to next time
    timerState.currentTimeIndex++;
    timerState.currentTime = new Date( timerState.times[timerState.currentTimeIndex + 1]);
  };

  useEffect(()=>{  if(ccdata?.isAutoRechEnabled == "Y" &&  thresholdAmt != ccdata?.thresholdAmt ){setShowUpdate(true)}},[thresholdAmt])
  
  useEffect(() => { getAutoRechargeDetails();}, []);

  const getCreditCardDtls = () => {
    setLoading(true);
    getCreditCardDetails()
      .then((res) => {
        console.log("getCreditCardDtls", res);
        if (res.statusCode == 200) {
          setData(res?.data || []);
          setCreditCardModal(true);
        }
        if (res.statusCode == -1057) {
          setErrMessage(res.message || "");
          setErrModalVisible(true);
          setAlertModal({ title: "Error",  status: "error", message: res.message, navigateScreen: "", });
        }else if( res.statusCode == 500 ){
          setAlertModalVisible(true)
          setAlertModal({ title: "Error",  status: "error", message: res.message, navigateScreen: "", });
        }
      })
      .catch((err) => { console.log("getCreditCardDtls", err);})
      .finally(() => {setLoading(false); });
  };

  const getAutoRechargeDetails = () => {
    setLoading(true);
    let fastagId = "";
    if (selectedVrnData?.length) {
      fastagId = selectedVrnData[0].fastagId;
    }
    let params = { vrn: selectedVrn,poolAccountNumber:"" };
    getAutoRechargeDtls(params)
      .then((res) => {
        setccData(res.data);
        setAmount(res?.data?.rechargeAmt || "500");
        setThresholdAmt(res?.data?.thresholdAmt);
        setIsEdit(res?.data?.isAutoRechEnabled == "N" ? true : false);
      })
      .catch(() => {})
      .finally(() => { setLoading(false); });
  };

  const getOtp = (item) => {
    console.log(selectedVrnData);
    var params = { id: global.userCd,  type: "autoRecharge",};
    setLoading(true);
    setCreditCardModal(false);
    sendOtp(params)
      .then((response) => {
        let res = response?.data;
        if (res.statusCode == 1003 || res.statusCode == 200) {
          setLoading(false);
          setRequestId(res?.response);
          setOtpMsg(res.message);
          setOtpData(res);
          setOtpModalVisible(true);
        } else if ( res.statusCode == -1052 || res.statusCode == 500 || res.statusCode == -1017 ||  res.statusCode == -1003 || res.statusCode == -1004 ) {
          setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK", });
          setAlertModalVisible(true);
          setLoading(false);
        }
      })
      .catch((err) => {
        setAlertModal({ title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK", });
        setAlertModalVisible(true);
        setLoading(false);
      });
  };

  const onClickValidateOtp = () => {
    let fastagId = 0;
    if (selectedVrnData?.length) { fastagId = selectedVrnData[0].fastagId; }
    let reqObj = {
      requestId: requestId?.otp,
      otp: otp,
      type: "autoRecharge",
      vrn: selectedVrn || "",
      cardSerno:  selectedCard.cardSerNo || ccdata?.cardSerNo ,
      maskedCard: selectedCard.maskedCardNumber || ccdata?.maskedCardNo,
      maskedCardNumber: selectedCard.maskedCardNumber || ccdata?.maskedCardNo,
      thresholdAmt: thresholdAmt,
      rechargeAmt: amount,
      tagId: fastagId || "",
      poolAccountNumber:""
    };
    setApiLoader(true);
    validateOtpWithToken(reqObj)
      .then((res) => {
        setOtp("");
        if (res.statusCode == 200 || res.statusCode == 1020 || res.statusCode == 1034 || res.statusCode == 1053) {
          setApiLoader(false);
          setOtpModalVisible(false);
          setOtpNbr("");
          setAlertModal({title: "Successful", status: "success",message: res.message, navigateScreen: "",actionButton: "OK", });
          setAlertModalVisible(true);
        } else if ( res.statusCode == -1020 || res.statusCode == 500 ||res.statusCode == -1008 || res.statusCode == -1053 ||res.statusCode == -1017 || res.statusCode < 0 ) {
          setOtpModalVisible(false);
          setAlertModal({ title: "Error", status: "error", message: res.message,  navigateScreen: "", actionButton: "OK",});
          setAlertModalVisible(true);
          setApiLoader(false);
          setOtpNbr("");
        } else {
          setOtpModalVisible(false);
          setAlertModal({ title: "Error", status: "error", message: res.message,  navigateScreen: "", actionButton: "OK",});
          setAlertModalVisible(true);
          setApiLoader(false);
          setOtpNbr("");
        }
      })
      .catch((err) => {
        setOtpModalVisible(false);
        setAlertModal({ title: "Error", status: "error", message: err.message,  navigateScreen: "", actionButton: "OK",});
        setAlertModalVisible(true);
        setApiLoader(false);
        setOtpNbr("");
      });
  };

  const renderCard = () => {
    return data.map((item, index) => {
      return (
        <View key={index} style={styles.cardCreditStyle} >
          <View style={styles.viewStyle}>
            <CText.creditCardTitle>{"IDFC FIRST Bank Credit Card"} </CText.creditCardTitle>
             <Image source={ item.prdctShortCode == "VISA" ? require("../../assets/images/visa.png"): item?.prdctShortCode == "RUPAY" ? require("../../assets/images/rupay.png") : require("../../assets/images/master.png")}
              style={{width: 41.2,  height: item?.prdctShortCode == "MASTER" ? 23.7 : 11.7, }} />
          </View>
          <CText.cardNumber> {item.maskedCardNumber}</CText.cardNumber>
          <View style={styles.btnWidget}>
            <CustomButton text={"Link and Setup"} textStyle={styles.linkText}
              onPress={() => {
                getOtp();
                setSelectedCard(item);
              }}
            />
          </View>
        </View>
      );
    });
  };
  const onCloseModal = () => { setAlertModalVisible(false); RootNavigation.navigate("Profile/MyVehicles") };
  return (
    <View style={styles.container}>
      <View style={styles.backIconViewStyle}>
        <TouchableOpacity onPress={() => RootNavigation.navigate("Profile/MyVehicles")}>
          <CImage.backIcon></CImage.backIcon> 
        </TouchableOpacity>
        <Text style={styles.viewVehicleTextStyle}>{"Auto Recharge"}</Text>
      </View>
      <View style={styles.contentViewStyle}>
        <View>
          <Text style={styles.headingTextStyle}>  {"Recharge when my balance goes below"} </Text>
          <View style={styles.cardViewStyle}>
            <CImage.CarImgAR></CImage.CarImgAR>
            <View style={{ marginLeft: 10 }} >
              <View style={styles.cardWidget} >
                <Text style={[styles.userDetailsKeyTextStyle,{flex:3}]}>{"Owner Name"} </Text>
                <Text style={[ styles.userDetailsKeyTextStyle,{ marginHorizontal: 10,flex:0.5},]} > {":"} </Text>
                <Text style={[styles.userDetailsKeyTextStyle,{flex:4.5}]}> {global?.fullName} </Text>
              </View>
              <View style={styles.cardWidget} >
                <Text style={[styles.userDetailsKeyTextStyle,{flex:3}]}>{"IDFC Tag Class"} </Text>
                <Text style={[  styles.userDetailsKeyTextStyle, { marginHorizontal: 10,flex:0.5 }, ]} > {":"}  </Text>
                <Text style={[styles.userDetailsKeyTextStyle,{flex:4.5}]}>{selectedVrnData[0]?.tagClass}</Text>
              </View>
              <View style={styles.cardWidget} >
                <Text style={[styles.userDetailsKeyTextStyle,{flex:3}]}>{"Vehicle"} </Text>
                <Text style={[ styles.userDetailsKeyTextStyle, { marginHorizontal: 10,flex:0.5}, ]} > {":"} </Text>
                <Text style={[styles.userDetailsKeyTextStyle,{flex:4.5}]}> {selectedVrnData[0]?.vehicleModel}  </Text>
              </View>
            </View>
          </View>
          <View style={{ marginTop: 20 }}>
            <Text style={styles.headingTextStyle}>  {"Recharge when my balance goes below"} </Text>
            <View>
              <TextInput style={[  styles.textInputStyle,  { backgroundColor: isEdit ? "#fff" : "#f8f8f8" }, ]} maxLength={6} value={thresholdAmt} onChangeText={(t) => (isNaN(t) ? "" : t.includes(".") ?"": setThresholdAmt(t))} editable={isEdit} />
              {isEdit ? ( null ) : ( 
              <TouchableOpacity style={styles.editLink} onPress={() => setIsEdit(true)}> 
              <CText.editText>  {"Edit"}</CText.editText>
              </TouchableOpacity>)}
            </View>
          </View>
        </View>
        <View style={styles.secondViewStyle}>
          <Text style={styles.headingTextStyle}>{"Recharge with"}</Text>
          <View style={styles.quickAddButtons}>
            <TouchableOpacity style={[ styles.quickAddButton, {backgroundColor: amount == 500 ? "#ffffff" : "#ffdfe2", borderWidth: amount == 500 ? 1 : 0, borderColor: amount == 500 ? "#bd2d37" : null,},]}
              onPress={() => {setAmount(500)
                ccdata?.isAutoRechEnabled == "Y" ? setShowUpdate(true) : ()=>{}
              }}>
              <CText.qabInnerText>500</CText.qabInnerText>
            </TouchableOpacity>
            <TouchableOpacity style={[styles.quickAddButton, {backgroundColor: amount == 1000 ? "#ffffff" : "#ffdfe2",borderWidth: amount == 1000 ? 1 : 0, borderColor: amount == 1000 ? "#bd2d37" : null, }]}
              onPress={() => {setAmount(1000)
                ccdata?.isAutoRechEnabled == "Y" ? setShowUpdate(true) : ()=>{}}} >
              <CText.qabInnerText>1000</CText.qabInnerText>
            </TouchableOpacity>
            <TouchableOpacity style={[ styles.quickAddButton,{ backgroundColor: amount == 1500 ? "#ffffff" : "#ffdfe2",borderWidth: amount == 1500 ? 1 : 0,borderColor: amount == 1500 ? "#bd2d37" : null,}, ]}
              onPress={() => {setAmount(1500)
                ccdata?.isAutoRechEnabled == "Y" ? setShowUpdate(true) : ()=>{}}} >
               <CText.qabInnerText>1500</CText.qabInnerText>
            </TouchableOpacity>
          </View>
          <CText.selectNumberText> {"Select different number if you wish change the recharge amount"} </CText.selectNumberText>
          {ccdata?.isAutoRechEnabled !== "N" ? (
            <View>
              <View style={styles.cardSpace} >
                <Text style={[ styles.headingTextStyle, { marginTop: 15,}]}> {"Selected Payment Method"} </Text>
                <TouchableOpacity onPress={() => getCreditCardDtls()}> 
                 <Text style={[styles.headingTextStyle,{ marginTop: 15, color: "#cb0303", marginLeft: 20 } ]} > {"Change"} </Text>
                </TouchableOpacity>
              </View>
              <View style={styles.creditCardWidget} >
                <View style={styles.viewStyle}>
                  <CText.creditCardText>  {"IDFC FIRST Bank Credit Card"} </CText.creditCardText>
                  <Image source={ ccdata?.prdctShortCode == "VISA" ? require("../../assets/images/visa.png")  : ccdata?.prdctShortCode == "RUPAY" ? require("../../assets/images/rupay.png") : require("../../assets/images/master.png") }
                    style={{ width: 41.2, height: ccdata?.prdctShortCode == "MASTER" ? 23.7 : 11.7, }}/>
                </View>
                <CText.maskedCardNumber> {ccdata?.maskedCardNo} </CText.maskedCardNumber>
              </View>
            </View>
          ) : (
            <View>
              <Text style={[ styles.headingTextStyle,{marginTop: 15} ]}> {"Choose from Available Payment Methods"}</Text>
              <TouchableOpacity style={styles.paymentMethodViewStyle}  onPress={() => getCreditCardDtls()} >
                <Text style={styles.paymentMethodTextStyle}> {"IDFC FIRST Bank Credit Card"} </Text>
                <CImage.IconRightAR></CImage.IconRightAR>
              </TouchableOpacity>
            </View>
          )}
        </View>
        {!showUpdate  ? ( null ) : ( 
          <View style={styles.updateButtonStyle}>
          <CustomButton text={"Update"} onPress={()=>getOtp()}/>
          </View> )}
      </View>
      <View>
        <QuickLinks />
      </View>
      {creditCardModal ? (
        <View style={styles.overlayViewStyle}>
          <View style={styles.overlayContainer}>
            <View style={styles.creditOverlay}>
              <TouchableOpacity  style={{alignSelf:"flex-end",}} onPress={() => setCreditCardModal(false)}> 
               <CText.closeText> {"X"}</CText.closeText> 
               </TouchableOpacity>
              <CText.selecARText> {"Please select a card for setting up Auto Recharge"} </CText.selecARText>
              <View> 
                 <View style={styles.viewStyle1} > {renderCard()} </View>
              </View>
            </View>
          </View>
        </View> ) : null}
      {otpModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <View style={styles.overlayContainer}>
            <View style={styles.overlay}>
              <View style={styles.overlayContentViewStyle}>
                <Text style={styles.enterOtpTextStyle}>{"Enter OTP"}</Text>
                <Text style={styles.otpDescTextStyle}> {get(otpData, "message", "")}</Text>
                <View style={{ alignSelf: "center" }}>
                  <CustomInput
                    onValueChanged={(e) => setOtp(e)}
                    value={otp}
                    keyboardType="numeric"
                    pattern={/^\d{6}$/}
                    errorMessage={"Enter Valid OTP"}
                    maxLength={6}
                    style={[styles.otpInputViewStyle, { alignSelf: "center" }]}
                  />
                </View>
                <View style={styles.resendViewStyle}>
                  <Countdown
                    ref={counterRef}
                    date={timerState.currentTime}
                    key={timerState.currentTimeIndex}
                    onComplete={completeTime}
                    intervalDelay={0}
                    precision={3}
                    renderer={timerRenderer}
                  />
                </View>
                <View style={styles.footerWidget} >
                  <CustomButton text={"Submit"} onPress={() => { !otpPattern.test(otp) ? ()=>{} : onClickValidateOtp();}} disable={!otpPattern.test(otp) ? true : false} />
                </View>
              </View>
            </View>
          </View>
        </View>
      ) : null}
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert title={alertModal.title} status={alertModal.status} message={alertModal.message} navigateScreen={alertModal.navigateScreen} actionButton={"OK"} onCloseModal={onCloseModal} />
        </View>
      ) : null}
      {errModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlertForTwoButtons
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton1={"Later"}
            actionButton2={"Apply Now"}
            onPressActionButton1={() => {  setErrModalVisible(false);  }}
            onPressActionButton2={() => {setErrModalVisible(false)
              Linking.openURL(global?.AUTO_RECHARGE_APPLY_LINK)
            }}
            backgroundColor={"#bd2d37"}
            color={"#ffffff"}
          />
        </View>
      ) : null}
      {loading && <Loader />}
    </View>
  );
};
//make this component available to the app
export default AutoRecharge;
